<template>
  <div class="messaging-sidebar">
    <div class="messaging-sidebar--dsk">
      <div v-if="sidebar === 'no-details'">
        <a class="mr" @click="goBack">
          <img :src="images.arrow" alt="go back">
        </a>
      </div>
      <div
        v-if="sidebar === 'details'"
        class="messaging-sidebar__info"
      >
        <a class="mr" @click="goBack">
          <img :src="images.arrow" alt="go back">
        </a>
        <img class="messaging-sidebar__dp" :src="getSelectedContact.photo_url_absolute" alt="Provider Photo">
        <h3 class="h3 mb0" >{{ getSelectedContact.fullname }}</h3>
        <p class="p m0 small">{{ getSelectedContact.speciality }}</p>
      </div>
      <div v-if="sidebar === 'messages'">
        <ul>
          <li
            v-for="(item, key) in messagesNavItems"
            :key="key"
            :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
            :class="[
              'mt','c-accent','cp',
              {
                'fw-bold': item.link === stage
              }
            ]"

            @click="switchBetween(item.link)"
          >
            {{ item.label }}
          </li>
        </ul>
      </div>
    </div>
    <div class="messaging-sidebar--mbl">
      <div v-if="sidebar === 'messages'">
        <ul>
          <li
            v-for="(item, key) in messagesNavItems"
            :key="key"
            :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
            :class="[
              'mt','c-accent','cp','fw-bold',
              {
                'visuallyhidden' : item.link === stage,
              }
            ]"

            @click="switchBetween(item.link)"
          >
            {{ item.label }} <img :src="images.arrowRight" :alt="stage">
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

// Vuex
import { mapGetters, mapActions } from 'vuex';

import arrowRight from 'images/icons/arrow-right.svg';
import arrow from 'images/icons/icon-chevron-left.svg';

// Images
const images = {
  arrowRight,
  arrow,
};

export default {
  name: 'ui-messaging-sidebar',

  // Data
  data() {
    return {
      stage: this.$route.params.id,
      images,
      messagesNavItems: [
        {
          label: 'Received Messages',
          link: 'inbox',
        },
        {
          label: 'Sent Messages',
          link: 'outbox',
        },
      ],
    };
  },

  computed: {
    ...mapGetters('messaging', ['getSelectedContact']),
    ...mapGetters('app', ['org']),

    sidebar() {
      if(this.stage === 'inbox' || this.stage === 'outbox') {
        return 'messages';
      }
      else if (localStorage.getItem('contactID')) {
        return 'details';
      }

      return 'no-details';
    },
  },

  methods: {
    ...mapActions('messaging', ['deleteSelectedContact']),

    goBack() {
      const previousStage = localStorage.getItem('messagesPreviousStage') === 'compose' ? 'inbox' : localStorage.getItem('messagesPreviousStage');
      if(previousStage !== 'view') {
        localStorage.removeItem('contactID');
      }
      this.$router.push(`/messages/${previousStage}`);
    },

    switchBetween(switchTo) {
      this.$router.push(`/messages/${switchTo}`);
    },
  },

};
</script>



// WEBPACK FOOTER //
// MessagingSidebar.vue?53c4da57